import { Component, Input, LOCALE_ID, inject } from '@angular/core';
import { ContractDetail } from '../../../models/contract-model';
import { DateFormatType } from '../../../enums/date-format-type.enum';
import { DateUtility } from '../../../date.utility';
import { Consumed } from '../../../enums/consumed-payment-verify';
import { AppMediatorService } from '../../../services/app-mediator.service';
import { FeatureToggleService } from '../../../services/feature-toggle.service';

@Component({
    standalone: false,
    selector: 'por-contract-payment-history-modal',
    templateUrl: './contract-payment-history-modal.component.html',
    styleUrls: ['./contract-payment-history-modal.component.scss']
})
export class ContractPaymentHistoryModalComponent {
    readonly appMediatorService = inject(AppMediatorService);
    readonly featureToggleService = inject(FeatureToggleService);

    @Input() contractDetail!: ContractDetail[] | null;

    dateFormat: string;
    consumed = Consumed;

    constructor() {
        const locale = inject(LOCALE_ID);

        this.dateFormat = DateUtility.getDateDisplayFormat(DateFormatType.StandardDate, locale);
    }

    isPaymentMethodAvailable() {
        return this.contractDetail?.some(x => x.Payment?.some(y => y.PaymentMethod));
    }
}
